/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { Outlet } from "react-router-dom";
import { Grid, Paper } from "@mui/material";
import SidePanel from "../Components/SidePanel/SidePanel";
import NavBar from "../Components/NavBar/NavBar";

const AdminLayout = () => {
    return (
        <>
            <NavBar />
            <Grid container>
                <Grid item xs={3}>
                    <SidePanel />
                </Grid>
                <Grid item xs={9}>
                    <Outlet />
                </Grid>
            </Grid>
        </>
    );
}

export default AdminLayout